<template>
  <div class="needs-manage">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="needs-manage-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
      >

        <template slot="status" slot-scope="scope">
          <div class="condition-word" :class="['stateTopdiv', `color_${scope['row']['status']}`]">
            {{scope['row']['status'] == 1?'继续跟踪':scope['row']['status'] == 2?'需求已转化':scope['row']['status'] == 3?'无相关需求':'-'}}
          </div>
        </template>

        <template slot="menuRight">
          <el-tooltip
            class="item"
            effect="dark"
            content="显隐"
            placement="top"
          >
            <el-button
              icon="el-icon-s-operation"
              circle
              @click="operation"
            ></el-button>
          </el-tooltip>
        </template>

        <template slot="menuLeft">
          <el-button
            size="small"
            icon="el-icon-download"
            @click="exportShow"
          >导出数据
          </el-button>
        </template>        
        
        <template slot-scope="scope" slot="menu">
          <div style="text-align:left">
            <el-button
              type="success"
              plain
              size="small"
              icon="el-icon-arrow-right"
              @click.stop="handleDetails(scope.row.id)"
              >详情
            </el-button>
          </div>
        </template>        
      </avue-crud>
    </div>

    <ExportData ref="exportData" @exportDownload="exportDownload" />
    <Options
      ref="Options"
      :plainOptions="optionColumn"
      :pageDataId="this.$route.path"
      @returnData="returnData"
    />
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import { needsManageConfig } from './needsManageConfig'
import ExportData from "@/components/exportData/exportData";
import Options from "@/components/ShowHidden/showhidden";
import { downLoadTemplate } from "@/router/downLoadTem";
import * as api from "@/api/zd/needsManage";
export default {
  name: 'needsManageTable',
  data() {
    return {
      searchForm: {},
      tableData: [],
      tableConfig: needsManageConfig(),
      files: [],
      optionColumn: '',
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10
      },      
    }
  },
  components: {
    TagsCloud,
    Options,
    ExportData
  },
  mounted() {
    this.optionColumn = this.deepClone(this.tableConfig.column)
  },

  activated() {
    this.queryTableData()
  },
  methods: {
    // 查看详情
    handleDetails(id) {
      this.$router.push({
        path: `/zd/needsManage/needsDetail/${id}`
      })
    },

    handleEdit(id) {},

    handleDelete(id) {},
    // 列显隐
    operation() {
      // let origencolum = this.option.column;
      this.$refs.Options.showmode();
    },
    
    returnData(data) {
      if(data.length!=0) {
        this.tableConfig.column = data;
      }
    },

    cloudTages(data) {
      this.files = data;
    },
    queryTableData() {
      let self = this
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm
      }
      api.getNeedsList(params).then(res => {
        // console.info(res)
        self.tableData = res.data.data.records
        self.page.total = res.data.data.total
      })
    },
    searchReset() {
      this.searchForm = {}
      this.queryTableData()
    },

    searchChange(form, done) {
      console.info(this.searchForm)
      this.searchForm.status = this.searchForm.demandStatus
      this.queryTableData()
      done()
    },

    // 排序
    sortChange(val) {
      this.searchForm.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";
      this.form.orderName = val.prop;
      this.page.currentPage = 1;
      this.queryTableData()
    },

    pageReset() {
      this.page = {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10
      }
    },

    exportShow() {
      this.$refs.exportData.showModel();
    },

    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.query,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.query,
        };
      }
      downLoadTemplate("/api/cust/demand/export", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });      
    }    
  }
}
</script>
<style lang="scss" scoped>
.needs-manage{
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .needs-manage-table{
    background: #ffff;
    padding: 16px;
  }
  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .color_1::before {
    background: #FEC03D;
  }
  .color_2::before {
    background: #51d351;
  }
  .color_3::before {
    background: #ccc !important;
  }  
}
.input_width {
  width: 220px;
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>